import ManagerAvatar from './ManagerAvatar';
import { getManagerTagline } from '../../utils/managers';

// Trash talk / peer review card.
// Usage: <QuoteCard quote="Cute draft, Josh." manager="Anna" subtitle="RE: JOSH'S 1ST PICK" accent="gold" />

export default function QuoteCard({ quote, manager, subtitle, accent = 'gold' }) {
  const borderClass = {
    gold: 'border-l-[3px] border-accent-gold',
    red: 'border-l-[3px] border-accent-red',
    muted: 'border-l-[3px] border-ink-tertiary',
  }[accent] || 'border-l-[3px] border-accent-gold';

  return (
    <div className={`bg-bg-surface p-6 ${borderClass}`}>
      <p className="text-lg leading-relaxed italic mb-5">"{quote}"</p>
      <div className="flex items-center gap-3">
        <ManagerAvatar name={manager} size="sm" />
        <div>
          <div className="text-sm font-black">{manager.toUpperCase()}</div>
          <div className="text-[9px] text-ink-tertiary tracking-[0.15em]">{subtitle || getManagerTagline(manager).toUpperCase()}</div>
        </div>
      </div>
    </div>
  );
}
